
import { useTranslation } from 'src/utils/i18n'
import Image from 'next/image'
import { appendSetupQuery } from 'src/utils/resolveCurrentOrderId'

const NewFooter = ({ nowPage, setNowPage, startMonitoring, showFlag = false, setIsAgree }) => {

  const { t } = useTranslation('commonAndroid')

  return (
    <div className={`w-full h-[75px] flex justify-center items-center [border-top:1px_solid_#E5E7EB] absolute bottom-0 cursor-pointer bg-[#FFFFFF] ${showFlag ? 'hidden' : ''} select-none z-[52]`}>
      <div className={`w-full lg:w-[620px] flex ${nowPage === 17 ? 'justify-center' : 'justify-between'}`}>
        <div className={`w-max flex p-[6px_19px_6px_10px] [border:1px_solid_#454CFF] smj:ml-[16px] rounded-[18px] ${nowPage === 17 ? 'hidden' : ''}`} onClick={() => {
          if (nowPage === 1) setNowPage(0)
          else if (nowPage === 0) window.location.assign(appendSetupQuery('/android/classification'))
          else setNowPage(nowPage - 1)
          if (nowPage === 12) setNowPage(3)
          if (nowPage === 3) setNowPage(0)
          if (nowPage === 16) setNowPage(14)
        }}>
          <Image src='/images/bind/bind-arrow-blue.svg' width={18} height={18} alt='' />
          <span className='text-[15px] text-[#454CFF] font-[600] leading-[22px] ml-[7px]'>{t('BACK')}</span>
        </div>

        <div className={`w-max flex p-[6px_19px_6px_10px] bg-[#FFCF55] smj:mr-[16px] pl-[24px] pr-[10px] rounded-[18px] ${[1, 12, 17].includes(nowPage) ? 'hidden' : ''}`} onClick={() => {
          if (nowPage !== 12) setNowPage(nowPage + 1)
          if (nowPage === 3) setNowPage(12)
          if (nowPage === 0) setNowPage(3)
          if (nowPage === 14) setNowPage(16)
        }}>
          <span className='text-[15px] text-[#1B1C2B] font-[600] leading-[22px] mr-[6px]'>{t('NEXT')}</span>
          <Image src='/images/bind/bind-arrow-black.svg' width={18} height={18} alt='' />
        </div>

        <div className={`w-max flex bg-[#FFCF55] smj:mr-[16px] px-[19px] py-[7px] rounded-[18px] ${nowPage !== 12 || nowPage === 17 ? 'hidden' : ''}`} onClick={startMonitoring}>
          <span className='text-[14px] text-[#1B1C2B] font-[600] leading-[22px]'>{t('Start monitoring')} </span>
        </div>

        <div className={`w-[130px] flex justify-center items-center p-[7px_19px_7px_10px] bg-[#FFCF55] px-[19px] rounded-[18px] ${nowPage !== 17 ? 'hidden' : ''} text-nowrap`} onClick={() => {




          setTimeout(() => {
            window.location.assign('/')
          }, 1500)
        }
        }>
          <span className='text-[14px] text-[#1B1C2B] font-[600] leading-[22px]'>{t('Complete')}</span>
        </div>
      </div>
    </div>
  )
}

export default NewFooter
